/**
 * 사이드바 네비게이션 섹션 버전 선택기
 * props 또는 환경변수로 버전을 동적으로 전환 가능
 */ import React from 'react';
// 세 가지 버전 import
import NavigationSectionOriginal from './NavigationSection';
import NavigationSectionHeroUI from './NavigationSection.heroui';
import NavigationSectionTabs from './NavigationSection.tabs';
export const NavigationSectionSelector = ({ version = 'tabs', ...props })=>{
    // 환경 변수로도 버전 제어 가능
    const envVersion = process.env.REACT_APP_NAV_VERSION;
    const finalVersion = envVersion || version;
    switch(finalVersion){
        case 'original':
            return /*#__PURE__*/ React.createElement(NavigationSectionOriginal, props);
        case 'heroui':
            return /*#__PURE__*/ React.createElement(NavigationSectionHeroUI, props);
        case 'tabs':
        default:
            return /*#__PURE__*/ React.createElement(NavigationSectionTabs, props);
    }
};
export default NavigationSectionSelector;
